type EventCallback = (...args: any[]) => void;

class EventBus {
  private listeners: Map<string, Set<EventCallback>> = new Map();

  on(event: string, callback: EventCallback): () => void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback);

    return () => {
      this.off(event, callback);
    };
  }

  off(event: string, callback: EventCallback): void {
    const listeners = this.listeners.get(event);
    if (listeners) {
      listeners.delete(callback);
      if (listeners.size === 0) {
        this.listeners.delete(event);
      }
    }
  }

  emit(event: string, ...args: any[]): void {
    const listeners = this.listeners.get(event);
    if (listeners) {
      for (const callback of listeners) {
        try {
          callback(...args);
        } catch (err) {
          console.error(`EventBus error in "${event}":`, err);
        }
      }
    }
  }

  once(event: string, callback: EventCallback): () => void {
    const wrapper: EventCallback = (...args) => {
      this.off(event, wrapper);
      callback(...args);
    };
    return this.on(event, wrapper);
  }

  removeAllListeners(event?: string): void {
    if (event) {
      this.listeners.delete(event);
    } else {
      this.listeners.clear();
    }
  }
}

export const eventBus = new EventBus();

export const GroupEvents = {
  CREATED: 'group:created',
  DISSOLVED: 'group:dissolved',
  RESIZED: 'group:resized',
  COLOR_CHANGED: 'group:colorChanged',
  NAME_CHANGED: 'group:nameChanged',
  NODE_ENTERED: 'group:nodeEntered',
  NODE_EXITED: 'group:nodeExited',
} as const;

export const CanvasEvents = {
  WORKFLOW_APPLY: 'canvas:workflowApply',
  WORKFLOW_EXECUTED: 'canvas:workflowExecuted',
  NODE_ADDED: 'canvas:nodeAdded',
  NODES_ADDED: 'canvas:nodesAdded',
  CONNECTION_ADDED: 'canvas:connectionAdded',
  CONNECTIONS_ADDED: 'canvas:connectionsAdded',
  VIEWPORT_FIT: 'canvas:viewportFit',
  AGENT_TASK_COMPLETED: 'canvas:agent:taskCompleted',
  AGENT_TASK_STATUS_CHANGED: 'canvas:agent:taskStatusChanged',
  TASK_COMPLETED: 'canvas:taskCompleted',
  // 🔴 根因修复：任务 WS（重）连成功——后端重启期间 in-flight 任务已被杀死，
  // 重连后需对本地 RUNNING 残留做一次后端校验（详见 useTaskEventListeners）
  TASK_WS_CONNECTED: 'canvas:taskWsConnected',
} as const;
